import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "common-scanner",
  "use": "common-scanner-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\" id=\"common-scanner\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 21.5V18.5H35V21.5H5ZM26 35V32H32V26H35V32C35 33.6569 33.779 35 32.2727 35H26ZM14 35H7.72727C6.22104 35 5 33.6569 5 32V26H8V32H14V35ZM26 5H32.2727C33.779 5 35 6.34315 35 8V14H32V8H26V5ZM14 5V8H8V14H5V8C5 6.34315 6.22104 5 7.72727 5H14Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol